<script>
    import R, {LOADER} from "../lib/requests";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";

    export let value;
    export let projectId = null;
    export let duration = null;
    export let disabled = false;

    let noPrice = false;

    const getPrice = () => {
        const onSuccess = result => {
            if (result.price) {
                noPrice = false;
                if (value && result.price != value) {
                    Alert.confirm("Τιμή χρέωσης", `Η χρέωση της εργασίας είναι ${value} ενώ του project είναι ${result.price}.\nΘέλετε να συνεχίσετε;`, () => {
                        value = result.price;
                        Notifier.showMessage("Η χρέωση ορίστηκε από το project");
                    })
                } else {
                    value = result.price;
                    Notifier.showMessage("Η χρέωση ορίστηκε από το project");
                }
                return;
            }
            noPrice = true;
            Notifier.showError("Το project δεν έχει χρεώσεις!");
        }

        const onFailure = err => {
        };

        const data = {
            duration,
            project_id: projectId,
        }

        R.handle(R.task.calculatePrice, data, onSuccess, onFailure, LOADER.POPUP);
    }

</script>


<div class="input-group">
    <input type="text" class="form-control" bind:value="{ value }"
           oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
           {disabled}
    />
    {#if projectId && duration}
        <button class="btn btn-default d-flex align-items-center" title="υπολογισμός από project"
                on:click="{ getPrice }" {disabled}>
            <AppIcon icon="project" strokeWidth="2" cssClass="me-1"/>
            από project
        </button>
    {/if}
</div>
{#if noPrice}
    <div class="text-danger">
        Το project δεν έχει χρώσεις
    </div>
{/if}